var image_viewer_rtlignore_default = {
  "fontElementMap": "R686G",
  "imageContainer": "_4AWxO",
  "expandButton": "-NfaT",
  "expandIcon": "_72jnp",
  "pointer": "_1IO0G",
  "imageWrapper": "AWrnO",
  "imageRatio": "_8fhQS",
  "image": "CJSKW",
  "imageOverlay": "J2S7o",
  "imagePreload": "_3b488",
  "imageHighres": "dC0y4",
  "onlyHighRes": "x8bcL",
  "image_loading": "QCGm8"
};
export {
  image_viewer_rtlignore_default as default
};
//# sourceMappingURL=image-viewer.rtlignore-scss.js.map
